import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PwaActivationRedirector — Redireciona o usuário para o fluxo de ativação
 * caso a aplicação seja aberta em modo Standalone (PWA) e possua um
 * token de ativação pendente salvo pelo navegador mobile comum.
 */
export function PwaActivationRedirector() {
  const navigate = useNavigate();

  useEffect(() => {
    // Detecta se está rodando no PWA Standalone (Android/iOS)
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    if (isStandalone) {
      const pendingToken = localStorage.getItem('ac_activation_token_pending');
      const pendingCode = localStorage.getItem('ac_activation_code_pending') || '';

      if (pendingToken) {
        console.log('[PWA] Standalone mode detected and pending activation token found. Redirecting...');
        
        // Consome os dados para não gerar redirecionamento infinito em re-renders
        localStorage.removeItem('ac_activation_token_pending');
        localStorage.removeItem('ac_activation_code_pending');

        // Navega para a página de ativação com o token resgatado
        const queryParams = new URLSearchParams();
        queryParams.set('token', pendingToken);
        if (pendingCode) {
          queryParams.set('code', pendingCode);
        }

        navigate(`/ativar?${queryParams.toString()}`, { replace: true });
      }
    }
  }, [navigate]);

  return null;
}
